import { Injectable } from '@angular/core';

@Injectable()
export class PageStateService {
    public currentLoyaltySitePage = 1;
    public currentUserPage = 1;
    public currentCustomerPage = 1;
    public currentTransactionLogPage = 1;
    public currentFraudReportPage = 1;
    public currentAuditReportPage = 1;
    public currentIssuePage = 1;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/page-state.service.ts